import { render, staticRenderFns } from "./fungsional.vue?vue&type=template&id=ca276d8c"
import script from "./fungsional.vue?vue&type=script&lang=js"
export * from "./fungsional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports